<template>
  <vx-card>
    <div class="mt-2 mb-4">
      <div style="display: flex; align-items: center;">
        <img
          src="@/assets/images/logo/logo-small.png"
          class="mr-4"
          style="display: inline-block;"
        />
        <div class="pt-4">
          <h2 class="mb-2">About Us</h2>
          <p>Malwation Corporation is a research and development company that was founded in 2020 and produces solutions on malware.</p>
          <p> Hypervisor-based automated malware analysis project is actively developed within the company.</p>
          <p>Developing new generation solutions against malware threats is the company's mission.</p>
        </div>
      </div>
    </div>
    <!-- <h5 class="mb-4 mt-4">IBAN Gösteren Belge</h5>
    <a href="#current_image">
      <img src="@/assets/images/iban.jpg" class="mr-4" style="display: inline-block; width: 500px;" />
    </a>
    <a href="#" class="lightbox" id="current_image">
      <img src="@/assets/images/iban.jpg" class="zoomed-image" />
    </a>-->
  </vx-card>
</template>

<script>
export default {};
</script>

<style>
.lightbox {
  /** Default lightbox to hidden */
  display: none;

  /** Position and style */
  position: fixed;
  z-index: 99999999;
  width: 100%;
  height: 100%;
  text-align: center;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
}

.lightbox img {
  /** Pad the lightbox image */
  max-width: 90%;
  max-height: 80%;
  margin-top: 5%;
}

.lightbox:target {
  /** Remove default browser outline */
  outline: none;

  /** Unhide lightbox **/
  display: block;
}
.zoomed-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>